import { render, staticRenderFns } from "./index-entry.vue?vue&type=template&id=40528576&"
import script from "./index-entry.vue?vue&type=script&lang=js&"
export * from "./index-entry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports